import React, { useState } from 'react';
import '../style/contact.css';
import PdfView from './PdfView';

function Contact() {
    const [isOpen, setIsOpen] = useState(false);
    return (
        <div className="contact">
            <div className="contact-top">
                <p className="contact-top__name">电话咨询</p>
                <p className="contact-top__num">0898-88913566</p>
            </div>
            <p
                className="contact-book"
                onClick={() => setIsOpen(!isOpen)}>招商手册</p>
            <p className="contact-text">招商热线</p>
            <p className="contact-text">0898-88913566</p>
            <p className="contact-text">联系邮箱</p>
            <p className="contact-text email">sanyayucaifagai@163.com</p>
            <PdfView isClose={isOpen} onOpen={(props) => setIsOpen(props)}/>
        </div>
    );
}

export default Contact;
